import { Assert } from "@seriously-rad/seriouslyrad-framework-core/Assert";
import { DataSource } from "@seriously-rad/seriouslyrad-framework-core/Data/DataSource";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { Dialog, DialogPropertyValues, IDialog } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/Dialog";
import { PropertyEditorSchedule } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/PropertyEditorSchedule";
import { PropertyEditorTextApplicationEntity } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/PropertyEditorTextApplicationEntity";
import { ValidationPanel } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ValidationPanel";
import { DialogResultEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Dialogs/DialogResultEnum";
import { NAMESPACE } from "./_Namespace";

export type ReportScheduleDialogPropertyValues =
    DialogPropertyValues
    & {
    };

export type ReportScheduleDialogProperties = {
    [name in keyof ReportScheduleDialogPropertyValues]: Property<ReportScheduleDialogPropertyValues[name]>
};

export interface IReportScheduleDialog extends IDialog, ReportScheduleDialogProperties
{
}

export class ReportScheduleDialog extends Dialog implements IReportScheduleDialog
{
    // #region Static

    public static override classNamespace = NAMESPACE + "ReportScheduleDialog";
    public static override className = "ReportScheduleDialog";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<ReportScheduleDialogPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                title: "Schedule Report",
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Global Variables

    protected propertyEditorReport?: PropertyEditorTextApplicationEntity;
    protected propertyEditorSchedule?: PropertyEditorSchedule;
    protected validationPanel?: ValidationPanel;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<ReportScheduleDialogPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Protected Methods

    protected _validate()
    {
        Assert.isNotNullOrUndefined(this.propertyEditorReport, "this.propertyEditorReport");
        Assert.isNotNullOrUndefined(this.propertyEditorSchedule, "this.propertyEditorSchedule");
        Assert.isNotNullOrUndefined(this.validationPanel, "this.validationPanel");

        const
            reportId = this.propertyEditorReport.value.get(),
            schedule = this.propertyEditorSchedule.value.get(),
            validationMessages = [];

        let
            isValid = true;

        this.propertyEditorReport.errorState.set(reportId ? false : true);
        this.propertyEditorSchedule.errorState.set(schedule ? false : true);

        if (!reportId)
        {
            validationMessages.push("Report is required");
            isValid = false;
        }

        if (!schedule)
        {
            validationMessages.push("Schedule is required");
            isValid = false;
        }

        this.validationPanel.setErrorMessages(validationMessages);

        return isValid;
    }

    // #endregion

    // #region Overrides

    protected override _createElement()
    {
        const
            $$element = super._createElement();

        this.validationPanel =
            new ValidationPanel();

        this.validationPanel.$$element.get()?.prependTo(this._containerWrapperElementRef.current);

        this.propertyEditorReport =
            new PropertyEditorTextApplicationEntity({
                dataSourceControlSelector: null,
                dataSourceControl: this,
                propertyDisplayName: "Report",
                primaryEntity: "Reports",
                primaryEntityDescriptionProperty: "name",
                dataSourceProperty: "reportId"
            }).appendTo(this);

        this.propertyEditorSchedule =
            new PropertyEditorSchedule({
                dataSourceControlSelector: null,
                dataSourceControl: this,
                editMode: true,
                propertyDisplayName: "Schedule",
                dataSourceProperty: "schedule"
            }).appendTo(this);

        return $$element;
    }

    public override async closeAsync()
    {
        if (this.dialogResult !== DialogResultEnum.ok)
            return;

        if (!this._validate())
            return;

        const
            dataSource = this.dataSource.get();

        this.promiseData = dataSource ? dataSource.data.get() : null;

        await super.closeAsync();
    }
    public override openAsync(reportId: string)
    {
        this.dataSource.set(new DataSource({
            data: {
                reportId: reportId,
                schedule: null
            }
        }));

        return super.openAsync(reportId);
    }

    // #endregion

    // #endregion
}

